import React, { useEffect, useState, useRef } from 'react';
// Menu and ArrowLeft no longer used here — mobile menu moved to Sidebar.tsx
// import { Menu, ArrowLeft } from 'lucide-react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { SidebarProvider, useSidebar } from './context/SidebarContext';
import { PermissionProvider } from './context/PermissionContext';
import { MobileBlocker } from './components/MobileBlocker';
import { Chat } from './pages/Chat';
import { PlaceholderPage } from './pages/PlaceholderPage';
import Welcome from './pages/Welcome';
import { Auth } from './pages/Auth';
import { Settings } from './pages/Settings';
import { SalesRegister } from './pages/SalesRegister';
import { DataUpload } from './pages/DataUpload';
import { AutomaticSync } from './pages/AutomaticSync';
import { PriceList } from './pages/PriceList';
import { Discounts } from './pages/Discounts';
import { Stock } from './pages/Stock';
import { Messages } from './pages/Messages';
import { InteractionCharts } from './pages/InteractionCharts';
import { Billing } from './pages/Billing';
import { supabase } from './lib/supabase';
import { Session } from '@supabase/supabase-js';
import { retrySupabase, onCircuitChange, isCircuitOpen } from './utils/retry';
// WelcomeModal component is temporarily disabled but kept in codebase
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { UpdateInfoModal } from './components/UpdateInfoModal';
import { GeneratedImagesHistory } from './pages/GeneratedImagesHistory';
import { Onboarding } from './pages/Onboarding';
import { EmployeeOnboarding } from './pages/EmployeeOnboarding';
import { OwnerOnboarding } from './pages/OwnerOnboarding';
import { AddFirstProduct } from './pages/AddFirstProduct';
import { BrandDescription } from './pages/BrandDescription';
import { MarketingPlanChat } from './pages/MarketingPlanChat';
import { MarketingPlanReview } from './pages/MarketingPlanReview';
import { CalendarRouter } from './pages/CalendarRouter';
import { Ayuda } from './pages/Ayuda';
import Paywall from './pages/Paywall';
import { ResetPassword } from './pages/ResetPassword';
import SeleccionarProductosAnuncio from './pages/SeleccionarProductosAnuncio';
import { ConfigurarAnuncio } from './pages/ConfigurarAnuncio';
import { SeleccionarObjetivoAnuncio } from './pages/SeleccionarObjetivoAnuncio';
import { SeleccionarFormatoAnuncio } from './pages/SeleccionarFormatoAnuncio';
import { SeleccionarEstiloAnuncio } from './pages/SeleccionarEstiloAnuncio';
import { EditarImagen } from './pages/EditarImagen';
import { EditarVideo } from './pages/EditarVideo';
import GeneratedImagesPage from './pages/GeneratedImagesPage';
import { SeleccionarTipoImagenAnuncio } from './pages/SeleccionarTipoImagenAnuncio';
import PersonalizarModeloAnuncio from './pages/PersonalizarModeloAnuncio';
import { ElegirFondoAnuncio } from './pages/ElegirFondoAnuncio';
import { SeleccionarComposicionAnuncio } from './pages/SeleccionarComposicionAnuncio';
import SeleccionarTextoEstudioVirtual from './pages/nuevo_modo/SeleccionarTextoEstudioVirtual';
import { SeleccionarModoAnuncio } from './pages/SeleccionarModoAnuncio';
import { SeleccionarPoseModelo } from './pages/SeleccionarPoseModelo';
import { TestV1 } from './pages/TestV1';
import PruebaNuevaInterfaz from './pages/nuevo_modo/PruebaNuevaInterfaz';
import PersonalizarModeloEstudioVirtual from './pages/nuevo_modo/PersonalizarModeloEstudioVirtual';
import AnadirAEscena from './pages/nuevo_modo/AnadirAEscena';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import Checkout from './pages/Checkout';
import DisenarVideo from './pages/DisenarVideo';
import ConfigurarVideoInfluencer from './pages/ConfigurarVideoInfluencer';
import ConfigurarVideoInfluencerNuevo from './pages/ConfigurarVideoInfluencerNuevo';
import ConfigurarVideoInfluencerDetalle from './pages/ConfigurarVideoInfluencerDetalle';
import ConfigurarVideoInfluencerVideo from './pages/ConfigurarVideoInfluencerVideo';
import ConfigurarVideoPersonalizado from './pages/ConfigurarVideoPersonalizado';
import ConfigurarVideoCinematografico from './pages/ConfigurarVideoCinematografico';
import PlanificadorVideoCinematografico from './pages/PlanificadorVideoCinematografico';
import GeneratedVideoPage from './pages/GeneratedVideoPage';
import { mergeLastCrearAnuncioState } from './utils/crearAnuncioStorage';
import UICatalog from './pages/UICatalog';
import UICatalog2 from './pages/UICatalog2';
import { Toaster } from 'sileo';
// AddToHomescreenPrompt is triggered manually from Settings page


// Using the new Welcome component instead of placeholder

function MaintenanceScreen() {
  const whatsappUrl = 'https://wa.me/5491122635392';
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(whatsappUrl)}`;
  return (
    <div className="min-h-screen bg-[#EFF0F5] flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 text-center max-w-xl w-full">
        <h1 className="text-lg font-semibold text-gray-900">Servidores en mantenimiento</h1>
        <p className="text-sm text-gray-700 mt-2">
          Los servidores se encuentran actualmente en mantenimiento, porfavor volvé en unos minutos.
        </p>
        <p className="text-sm text-gray-700 mt-2">
          Si no podés esperar para seguir generando imágenes, también podés contactarte con nosotros y preguntarnos en cuanto van a estar funcionando con normalidad
        </p>

        {/* Mobile: botón WhatsApp */}
        <div className="sm:hidden mt-5">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="h-10 px-4 inline-flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white rounded-full font-normal shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Preguntar
          </a>
        </div>

        {/* Desktop: QR + texto */}
        <div className="hidden sm:flex flex-col items-center mt-6">
          <img src={qrUrl} alt="QR WhatsApp" className="w-44 h-44" />
          <p className="text-sm text-gray-600 mt-2">Escaneá el código con la cámara del celular para contactarte por WhatsApp</p>
        </div>
      </div>
    </div>
  );
}

// Protected Route component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  // State for WelcomeModal is kept but unused while the modal is disabled
  // const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  
  // State for UpdateInfoModal
  const [showUpdateInfoModal, setShowUpdateInfoModal] = useState(false);
  const [updateMessage, setUpdateMessage] = useState<any>(null);
  const [userId, setUserId] = useState<string>('');
  // Poller control for update_disponible
  const updateIntervalRef = useRef<number | null>(null);
  const updateCheckerStartedRef = useRef(false);
  const updateChannelRef = useRef<any>(null);
  const systemChannelRef = useRef<any>(null);
  const DEBUG_UPDATE = false;

  // Maintenance mode (global) state
  const [maintenance, setMaintenance] = useState(false);
  // Company id cached from profile
  const [companyId, setCompanyId] = useState<string | null>(null);
  // Circuit breaker (503) state
  const [breakerOpen, setBreakerOpen] = useState(false);
  const [offline, setOffline] = useState<boolean>(typeof navigator !== 'undefined' ? !navigator.onLine : false);

  useEffect(() => {
    setBreakerOpen(isCircuitOpen());
    const off = onCircuitChange((s) => setBreakerOpen(s.open));
    return () => { try { off(); } catch {} };
  }, []);

  useEffect(() => {
    const update = () => setOffline(typeof navigator !== 'undefined' ? !navigator.onLine : false);
    update();
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  const refreshRubroCache = async (uid: string) => {
    try {
      const { data: profile } = await retrySupabase(async () =>
        await supabase
          .from('profiles')
          .select('id_company')
          .eq('id', uid)
          .single()
      );
      const idCompany: string | null = (profile as any)?.id_company ?? null;
      if (!idCompany) return;
      const { data: company } = await retrySupabase(async () =>
        await supabase
          .from('company_profiles')
          .select('rubro')
          .eq('id_company', idCompany)
          .single()
      );
      const rubro = (company as any)?.rubro as string | undefined;
      if (rubro) mergeLastCrearAnuncioState({ rubro });
    } catch {}
  };

  useEffect(() => {
    // Detect if the URL contains an OAuth hash fragment (implicit flow)
    const hasOAuthHash = window.location.hash?.includes('access_token');
    console.log('[Auth Debug] URL:', window.location.href);
    console.log('[Auth Debug] Hash:', window.location.hash?.substring(0, 80));
    console.log('[Auth Debug] hasOAuthHash:', hasOAuthHash);

    supabase.auth.getSession().then(({ data: { session } }) => {
      console.log('[Auth Debug] getSession result:', session ? `user=${session.user.id}` : 'null');
      setSession(session);
      if (session) {
        checkUserProfile(session.user.id);
        refreshRubroCache(session.user.id);
      } else if (!hasOAuthHash) {
        // Only stop loading if there's no pending OAuth redirect to process
        setLoading(false);
      }
      // If hasOAuthHash && !session, keep loading — onAuthStateChange will resolve it
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('[Auth Debug] onAuthStateChange:', event, session ? `user=${session.user.id}` : 'null');
      setSession(session);
      if (event === 'SIGNED_IN' && session?.user?.id) {
        checkUserProfile(session.user.id);
        refreshRubroCache(session.user.id);
      }
      // If we were waiting for OAuth hash processing and it failed, stop loading
      if (hasOAuthHash && !session) {
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const checkUserProfile = async (userId: string) => {
    try {
      // Store userId for later use with update info modal
      setUserId(userId);
      
      const { data: profile, error } = await retrySupabase(async () =>
        await supabase
          .from('profiles')
          .select('name, id_company, home_message, home_message_seen')
          .eq('id', userId)
          .single()
      );

      if (error) {
        console.error('Error fetching profile:', error);
        setLoading(false);
        return;
      }

      // Resolve canonical company UUID (id_company)
      const idCompany: string | null = (profile as any)?.id_company ?? null;
      setCompanyId(idCompany);

      // Check if user needs onboarding
      if (profile) {
        const hasCompany = Boolean(idCompany);
        // If both name and company are missing, start with personal info
        if (!profile.name && !hasCompany) {
          window.location.href = '/onboarding';
          return;
        }
        // If name exists but company is missing, redirect to onboarding (single entry point)
        else if (profile.name && !hasCompany) {
          window.location.href = '/onboarding';
          return;
        }
      }

      // If no profile issues, proceed to dashboard
      setLoading(false);
      
      // Check if there's an update message to show
      if (profile.home_message && profile.home_message_seen === false) {
        // home_message is already a JS object since it's a jsonb column in PostgreSQL
        setUpdateMessage(profile.home_message);
        setShowUpdateInfoModal(true);
      }
    } catch (err) {
      console.error('Error checking user profile:', err);
      setLoading(false);
    }
  };

  // Periodically check for company update flag and redirect to base URL if set
  useEffect(() => {
    if (!session || !companyId || updateCheckerStartedRef.current) return;
    updateCheckerStartedRef.current = true;
    let isMounted = true;
    // Handlers for immediate re-checks
    let visibilityHandler: (() => void) | null = null;
    let focusHandler: (() => void) | null = null;
    let onlineHandler: (() => void) | null = null;

    const setupUpdateChecker = async () => {
      try {
        if (DEBUG_UPDATE) console.log('[UpdateCheck] companyId (cached):', companyId);
        if (!isMounted) return;

        const checkAndHandleUpdate = async () => {
          try {
            const { data: companyRow, error: companyErr } = await retrySupabase(async () =>
              await supabase
                .from('company_profiles')
                .select('update_disponible')
                .eq('id_company', companyId)
                .single()
            );
            if (DEBUG_UPDATE && companyErr) console.warn('[UpdateCheck] company select error:', companyErr);
            if (DEBUG_UPDATE) console.log('[UpdateCheck] polled update_disponible:', (companyRow as any)?.update_disponible);
            const updateDisponible = (companyRow as any)?.update_disponible === true;
            if (updateDisponible) {
              // Attempt to reset flag before redirecting (best-effort)
              try {
                await supabase
                  .from('company_profiles')
                  .update({ update_disponible: false })
                  .eq('id_company', companyId);
                if (DEBUG_UPDATE) console.log('[UpdateCheck] reset update_disponible to false');
              } catch (_e) {
                // Ignore errors; proceed with redirect
                if (DEBUG_UPDATE) console.warn('[UpdateCheck] failed to reset flag, proceeding to redirect');
              }
              // Reload current page (keeps route) to apply update without moving tabs
              if (DEBUG_UPDATE) console.log('[UpdateCheck] reloading current page');
              window.location.reload();
            }
          } catch (_e) {
            // Silently ignore
            if (DEBUG_UPDATE) console.warn('[UpdateCheck] polling threw exception', _e);
          }
        };

        // Initial maintenance fetch (once) and initial update check
        try {
          const { data: sysRow, error: sysErr } = await retrySupabase(async () =>
            await supabase
              .from('config_system_atlas')
              .select('maintenance_mode')
              .eq('id', 1)
              .single()
          );
          if (DEBUG_UPDATE && sysErr) console.warn('[Maintenance] select error:', sysErr);
          const maintenanceMode = (sysRow as any)?.maintenance_mode === true;
          setMaintenance(maintenanceMode);
        } catch {}
        await checkAndHandleUpdate();

        // Realtime subscription for immediate updates
        try {
          // Clean previous channel if any
          if (updateChannelRef.current) {
            try { await supabase.removeChannel(updateChannelRef.current); } catch {}
            updateChannelRef.current = null;
          }
          const channel = supabase
            .channel(`company-update-${companyId}`)
            .on(
              'postgres_changes',
              { event: 'UPDATE', schema: 'public', table: 'company_profiles', filter: `id_company=eq.${companyId}` },
              (payload) => {
                if (DEBUG_UPDATE) console.log('[UpdateCheck] realtime payload:', payload);
                const newRow: any = (payload as any)?.new;
                if (newRow && newRow.update_disponible === true) {
                  // Best-effort reset then redirect
                  (async () => {
                    try {
                      await supabase
                        .from('company_profiles')
                        .update({ update_disponible: false })
                        .eq('id_company', companyId);
                      if (DEBUG_UPDATE) console.log('[UpdateCheck] realtime reset flag to false');
                    } catch {}
                    if (DEBUG_UPDATE) console.log('[UpdateCheck] realtime reload current page');
                    window.location.reload();
                  })();
                }
              }
            )
            .subscribe();
          updateChannelRef.current = channel;
          if (DEBUG_UPDATE) console.log('[UpdateCheck] realtime subscription started for company', companyId);

          // Clean previous system channel
          if (systemChannelRef.current) {
            try { await supabase.removeChannel(systemChannelRef.current); } catch {}
            systemChannelRef.current = null;
          }
          const sysChannel = supabase
            .channel('system-config')
            .on(
              'postgres_changes',
              { event: 'UPDATE', schema: 'public', table: 'config_system_atlas', filter: 'id=eq.1' },
              (payload) => {
                if (DEBUG_UPDATE) console.log('[Maintenance] realtime payload:', payload);
                const newRow: any = (payload as any)?.new;
                if (newRow && typeof newRow.maintenance_mode === 'boolean') {
                  setMaintenance(newRow.maintenance_mode === true);
                }
              }
            )
            .subscribe();
          systemChannelRef.current = sysChannel;
        } catch (_e) {
          // If realtime fails, polling still works
          if (DEBUG_UPDATE) console.warn('[UpdateCheck] realtime subscription failed', _e);
        }
        // Add event-driven immediate checks
        let running = false;
        let debounceTimer: number | null = null;
        const safeCheck = async () => {
          if (running) return;
          running = true;
          try { await checkAndHandleUpdate(); } finally { running = false; }
        };
        visibilityHandler = () => {
          if (document.visibilityState !== 'visible') return;
          if (debounceTimer) clearTimeout(debounceTimer);
          debounceTimer = window.setTimeout(safeCheck, 2000) as unknown as number;
        };
        focusHandler = () => {
          if (debounceTimer) clearTimeout(debounceTimer);
          debounceTimer = window.setTimeout(safeCheck, 2000) as unknown as number;
        };
        onlineHandler = () => {
          if (debounceTimer) clearTimeout(debounceTimer);
          debounceTimer = window.setTimeout(safeCheck, 2000) as unknown as number;
        };
        document.addEventListener('visibilitychange', visibilityHandler);
        window.addEventListener('focus', focusHandler as unknown as EventListener);
        window.addEventListener('online', onlineHandler as unknown as EventListener);
      } catch (_e) {
        // Ignore setup errors
      }
    };

    void setupUpdateChecker();

    return () => {
      isMounted = false;
      updateCheckerStartedRef.current = false;
      if (updateIntervalRef.current) {
        clearInterval(updateIntervalRef.current);
        updateIntervalRef.current = null;
      }
      // Cleanup realtime channel
      if (updateChannelRef.current) {
        try {
          supabase.removeChannel(updateChannelRef.current);
          if (DEBUG_UPDATE) console.log('[UpdateCheck] realtime channel removed');
        } catch {}
        updateChannelRef.current = null;
      }
      if (systemChannelRef.current) {
        try {
          supabase.removeChannel(systemChannelRef.current);
          if (DEBUG_UPDATE) console.log('[Maintenance] realtime channel removed');
        } catch {}
        systemChannelRef.current = null;
      }
      if (visibilityHandler) document.removeEventListener('visibilitychange', visibilityHandler);
      if (focusHandler) window.removeEventListener('focus', focusHandler as unknown as EventListener);
      if (onlineHandler) window.removeEventListener('online', onlineHandler as unknown as EventListener);
    };
  }, [session, companyId]);

  if (loading) {
    return (
      <>
        {(breakerOpen || offline) && (
          <div className="fixed top-0 left-0 right-0 z-[1000] pointer-events-none">
            <div className="mx-auto max-w-4xl sm:max-w-7xl px-4 pt-2">
              <div className="pointer-events-auto rounded-md bg-blue-50 border border-blue-200 text-blue-700 text-sm px-3 py-2 shadow-sm text-center">
                {offline ? 'Sin conexión a internet. Verificá tu conexión.' : 'Servidores en mantenimiento. Estarán operativos en unos minutos.'}
              </div>
            </div>
          </div>
        )}
        <div className="min-h-screen bg-[#EFF0F5] flex items-center justify-center">
          <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      </>
    );
  }

  if (maintenance) {
    return <MaintenanceScreen />;
  }

  if (!session) return <Navigate to="/auth" />;

  return (
    <>
      {(breakerOpen || offline) && (
        <div className="fixed top-0 left-0 right-0 z-[1000] pointer-events-none">
          <div className="mx-auto max-w-4xl sm:max-w-7xl px-4 pt-2">
            <div className="pointer-events-auto rounded-md bg-blue-50 border border-blue-200 text-blue-700 text-sm px-3 py-2 shadow-sm text-center">
              {offline ? 'Sin conexión a internet. Verificá tu conexión.' : 'Servidores en mantenimiento. Estarán operativos en unos minutos.'}
            </div>
          </div>
        </div>
      )}
      {children}
      {/* WelcomeModal disabled as requested but kept in codebase */}
      {/* <WelcomeModal isOpen={showWelcomeModal} onClose={() => setShowWelcomeModal(false)} /> */}

      {updateMessage && (
        <UpdateInfoModal
          isOpen={showUpdateInfoModal}
          onClose={() => setShowUpdateInfoModal(false)}
          message={updateMessage}
          userId={userId}
        />
      )}
    </>
  );
};
// Removed BetaTesterRoute guard per request (visual hide only)

const BetaTesterRoute = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) { if (mounted) { setAllowed(false); setLoading(false); } return; }
        const { data: profile } = await supabase
          .from('profiles')
          .select('id_company')
          .eq('id', user.id)
          .single();
        const idCompany: string | null = (profile as any)?.id_company ?? null;
        if (!idCompany) { if (mounted) { setAllowed(false); setLoading(false); } return; }
        const { data: company } = await supabase
          .from('company_profiles')
          .select('dev_tester, beta_tester')
          .eq('id_company', idCompany)
          .single();
        if (mounted) setAllowed((company as any)?.dev_tester === true || (company as any)?.beta_tester === true);
      } catch {
        if (mounted) setAllowed(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center w-full min-h-[80vh]">
        <div className="w-8 h-8 border-4 border-brand-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
};

// Layout with sidebar on desktop
const DashboardLayout = ({ children }: { children: React.ReactNode }) => {
  const { sidebarWidth } = useSidebar();
  // Track mobile menu state via custom event and compute panel width + viewport
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [panelWidth, setPanelWidth] = React.useState(0);
  const [isMobileView, setIsMobileView] = React.useState(false);
  const [hideMenuButton, setHideMenuButton] = React.useState(false);

  // Listen for hide-menu-button events from child components
  React.useEffect(() => {
    const handler = (e: Event) => {
      try {
        const detail = (e as CustomEvent).detail as any;
        if (typeof detail?.hide === 'boolean') {
          setHideMenuButton(detail.hide);
        }
      } catch {
        // noop
      }
    };
    window.addEventListener('hide-menu-button' as any, handler as EventListener);
    return () => window.removeEventListener('hide-menu-button' as any, handler as EventListener);
  }, []);

  React.useEffect(() => {
    const computePanelWidth = () => {
      const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
      const width = Math.min(320, Math.round(vw * 0.82));
      setPanelWidth(width);
    };
    const updateBreakpoint = () => {
      const isMobile = typeof window !== 'undefined' ? window.matchMedia('(min-width: 768px)').matches === false : true;
      setIsMobileView(isMobile);
    };
    computePanelWidth();
    updateBreakpoint();
    window.addEventListener('resize', computePanelWidth);
    window.addEventListener('resize', updateBreakpoint);
    return () => {
      window.removeEventListener('resize', computePanelWidth);
      window.removeEventListener('resize', updateBreakpoint);
    };
  }, []);

  React.useEffect(() => {
    const handler = (e: Event) => {
      try {
        const detail = (e as CustomEvent).detail as any;
        if (typeof detail?.isMobileMenuOpen === 'boolean') {
          setIsMobileMenuOpen(detail.isMobileMenuOpen);
        }
      } catch {
        // noop
      }
    };
    window.addEventListener('sidebar-mobile-toggle' as any, handler as EventListener);
    return () => window.removeEventListener('sidebar-mobile-toggle' as any, handler as EventListener);
  }, []);

  // OLD shell transform animation disabled — mobile menu now uses dropdown in Sidebar.tsx
  // const translateX = isMobileMenuOpen && isMobileView ? Math.max(0, panelWidth + 40 ) : 0;
  // const contentOffsetY = isMobileMenuOpen && isMobileView ? 40 : 0;
  // const depthZ = isMobileMenuOpen && isMobileView ? -200 : 0;
  // const perspectivePx = 1200;
  // const shellStyle = isMobileMenuOpen && isMobileView ? { transform: `perspective(...)`, ... } : { transform: 'none' };
  const shellStyle: React.CSSProperties = { transform: 'none' };

  // Avoid adding extra top padding on full-screen pages like Home ('/')
  const location = useLocation();
  const isRootPath = location.pathname === '/';
  const isCreateFlow = location.pathname.startsWith('/redes-sociales/crear-anuncio');
  const isEditImage = location.pathname.startsWith('/redes-sociales/editar-imagen');
  const isGeneratedImages = location.pathname.startsWith('/redes-sociales/imagenes-generadas');
  const isGeneratedVideo = location.pathname === '/redes-sociales/video-generado';
  // Pages that need special top padding handling
  const isSpecialTopPadding = isRootPath || isCreateFlow || isEditImage || isGeneratedImages || isGeneratedVideo;
  // Pages that should have NO bottom padding (full-bleed) - exclude crear-anuncio to give it bottom space
  const isFullBleedFlow = isRootPath || isCreateFlow || isEditImage || isGeneratedImages || isGeneratedVideo;
  const mainTopPadding = isSpecialTopPadding ? 'pt-14 md:pt-0' : 'pt-[calc(3.5rem+0.75rem)] md:pt-0';

  const searchParams = React.useMemo(() => new URLSearchParams(location.search), [location.search]);
  const estudioVirtualMobileNoMenu =
    isMobileView &&
    (
      (
        searchParams.get('estudio_virtual') === '1' &&
        (location.pathname === '/redes-sociales/crear-anuncio/personalizar-modelo' ||
          location.pathname === '/redes-sociales/crear-anuncio/personalizar-modelo-estudio-virtual' ||
          location.pathname === '/redes-sociales/crear-anuncio/seleccionar-pose' ||
          location.pathname === '/redes-sociales/crear-anuncio/seleccionar-texto-estudio-virtual')
      ) ||
      location.pathname === '/subscription'
    );

  // Ensure global scroll is not accidentally locked by any overlay/modals
  // Reset body/html overflow on mount and on route changes
  React.useEffect(() => {
    try {
      document.body.style.overflow = 'auto';
      (document.documentElement as HTMLElement).style.overflow = 'auto';
    } catch {
      // noop
    }
  }, [location.pathname]);

  const toggleMobileMenuFromLayout = () => {
    const newState = !isMobileMenuOpen;
    setIsMobileMenuOpen(newState);
    window.dispatchEvent(new CustomEvent('sidebar-mobile-toggle', {
      detail: { isMobileMenuOpen: newState }
    }));
  };

  return (
    <div className="bg-[#EFF0F5] min-h-[100svh] md:min-h-screen max-w-[100vw] overflow-x-hidden overflow-y-auto flex flex-col">
      <Sidebar />
      {/* OLD hamburger + arrow close buttons disabled — mobile menu now handled by Sidebar.tsx top bar */}
      {/* Transformable shell to mimic screen sliding right and shrinking */}
      <div
        className="relative z-30 md:z-auto transition-transform duration-500 ease-out transform-gpu bg-[#EFF0F5] md:bg-transparent md:min-h-0"
        style={shellStyle}
      >
        <main
          className={`flex-1 main-content overflow-x-hidden ${mainTopPadding} ${isFullBleedFlow ? 'full-bleed' : ''} bg-[#EFF0F5] md:bg-transparent`}
          style={{ maxWidth: '100vw' }}
        >
          <div className="w-full min-h-full md:transition-[padding] md:duration-300 md:ease-out" style={{ paddingLeft: isMobileView ? 0 : sidebarWidth }}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

function App() {
  return (
    <MobileBlocker>
      <Toaster position="top-right" theme="light" options={{ fill: '#FAFBFC' }} />
      <Router>
        <PermissionProvider>
          <SidebarProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/auth" element={<Auth />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/employee-onboarding" element={<EmployeeOnboarding />} />
            <Route path="/owner-onboarding" element={<OwnerOnboarding />} />
            <Route path="/add-first-product" element={<AddFirstProduct />} />
            <Route path="/restablecer-clave" element={<ResetPassword />} />
            <Route path="/ui-catalog" element={<UICatalog />} />
            <Route path="/ui-catalog-2" element={<UICatalog2 />} />
            
            <Route
              path="/asistente-ia"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Chat />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/test-v1"
              element={
                <ProtectedRoute>
                  <BetaTesterRoute>
                    <DashboardLayout>
                      <TestV1 />
                    </DashboardLayout>
                  </BetaTesterRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription/success"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SubscriptionSuccess />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <Navigate to="/redes-sociales/crear-anuncio/seleccionar-productos" replace />
              }
            />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Chat />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/registro-ventas"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SalesRegister />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/historial-ventas"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Historial de ventas" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/envios"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Envíos" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/productos"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PriceList />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stock"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Stock />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/descuentos"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Discounts />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/registro-compras"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Registro de compras" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/historial-compras"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Historial de compras" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/forecasting"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Forecasting" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/proveedores"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Proveedores" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/flujo-caja"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Flujo de caja" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/forecasting-financiero"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Forecasting financiero" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gastos-recurrentes"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Gastos recurrentes" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/mensajes"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Messages />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/graficos-de-interaccion"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <InteractionCharts />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientes"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlaceholderPage title="Clientes" />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subir-datos"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <DataUpload />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/sincronizacion-automatica"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AutomaticSync />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ayuda"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Ayuda />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configuracion"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Settings />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/billing"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Billing />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Paywall />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio"
              element={
                <ProtectedRoute>
                  <Navigate to="/redes-sociales/crear-anuncio/seleccionar-productos" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-productos"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarProductosAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-modo"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarModoAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/disenar-video"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <DisenarVideo />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/configurar-video-influencer-nuevo"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ConfigurarVideoInfluencerNuevo />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/configurar-video-influencer-detalle"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ConfigurarVideoInfluencerDetalle />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/configurar-video-influencer-video"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ConfigurarVideoInfluencerVideo />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/configurar-video-influencer"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ConfigurarVideoInfluencer />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/configurar-video-personalizado"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ConfigurarVideoPersonalizado />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/configurar-video-cinematografico"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ConfigurarVideoCinematografico />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/planificador-video-cinematografico"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PlanificadorVideoCinematografico />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/video-generado"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <GeneratedVideoPage />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/prueba-nueva-interfaz"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <BetaTesterRoute>
                      <PruebaNuevaInterfaz />
                    </BetaTesterRoute>
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-texto-estudio-virtual"
              element={
                <ProtectedRoute>
                  <BetaTesterRoute>
                    <DashboardLayout>
                      <SeleccionarTextoEstudioVirtual />
                    </DashboardLayout>
                  </BetaTesterRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/anadir-a-la-escena"
              element={
                <ProtectedRoute>
                  <BetaTesterRoute>
                    <DashboardLayout>
                      <AnadirAEscena />
                    </DashboardLayout>
                  </BetaTesterRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-objetivo"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarObjetivoAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-tipo-imagen"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarTipoImagenAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-formato"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarFormatoAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/personalizar-modelo"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PersonalizarModeloAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/personalizar-modelo-estudio-virtual"
              element={
                <ProtectedRoute>
                  <BetaTesterRoute>
                    <DashboardLayout>
                      <PersonalizarModeloEstudioVirtual />
                    </DashboardLayout>
                  </BetaTesterRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-pose"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarPoseModelo />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/elegir-fondo"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ElegirFondoAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-composicion"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarComposicionAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/seleccionar-estilo"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SeleccionarEstiloAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/crear-anuncio/configurar"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ConfigurarAnuncio />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/redes-sociales/calendario"
              element={
                <ProtectedRoute>
                  <BetaTesterRoute>
                    <DashboardLayout>
                      <CalendarRouter />
                    </DashboardLayout>
                  </BetaTesterRoute>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/redes-sociales/imagenes"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <GeneratedImagesHistory />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/redes-sociales/editar-imagen"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditarImagen />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/redes-sociales/editar-video"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditarVideo />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/redes-sociales/imagenes-generadas"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <GeneratedImagesPage />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/redes-sociales/marketing-plan-chat"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <MarketingPlanChat />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/redes-sociales/descripcion-brand"
              element={
                <ProtectedRoute>
                  {/* Render without DashboardLayout to disable Sidebar in this flow */}
                  <BrandDescription />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/redes-sociales/plan-marketing-view"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <MarketingPlanReview />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
          </SidebarProvider>
        </PermissionProvider>
      </Router>
    </MobileBlocker>
  );
}

export default App;